module.exports = __webpack_public_path__ + "img/icon-tips.2cc7c36a.png";